import { Tooltip, type TooltipProps } from 'antd';
import { forwardRef } from 'react';
import { Icon } from '../assets/icons';
import { cn } from '../lib/cn';
import { Typography } from './typography';

type TooltipElementProps = {
  content: string;
  contentPrefix?: string;
  className?: string;
  size?: number;
  iconColor?: string;
} & TooltipProps;

export const TooltipElement = forwardRef<SVGSVGElement, TooltipElementProps>(
  (
    { content, contentPrefix, className, size = 16, iconColor, ...props },
    ref
  ) => {
    return (
      <Tooltip
        color="white"
        title={
          <Typography
            className={cn('dark:text-neutral-1 p-1 text-gray-700', className)}
          >
            <span className="dark:text-neutral-1 font-medium text-gray-700">
              {contentPrefix && contentPrefix + ' '}
            </span>
            {content}
          </Typography>
        }
        {...props}
      >
        <Icon
          name="info-circle-transparent"
          className="hover:cursor-pointer"
          ref={ref}
          size={size}
          color={iconColor}
        />
      </Tooltip>
    );
  }
);

TooltipElement.displayName = 'TooltipElement';
